import React from "react";
import PropTypes from "prop-types";
import BaseIcon from "../../svg_icons/BaseIcon";

const StatCard = ({
    title,
    value,
    subtitle,
    icon,
    color = "#2563eb",
    onClick,
}) => {

    const renderIcon = () => {
        if (!icon) {
            return null;
        }

        // React element:
        //     <WalletCards />
        //     <svg>...</svg>
        if (React.isValidElement(icon)) { return icon; }

        // String:
        //     "users"
        //     "📋"
        if (typeof icon === "string") {
            return ( <BaseIcon name={icon} fallback={icon} /> );
        }

        return null;
    };

    return (
        <div
            onClick={onClick}
            style={{
                background: "#ffffff",
                border: "1px solid #e5e7eb",
                borderTop: `4px solid ${color}`,
                borderRadius: "16px",
                padding: "20px",
                cursor: onClick ? "pointer" : "default",
                transition: "all .2s ease",
                height: "100%",
                boxSizing: "border-box",
                minWidth: 0,
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform =
                    "translateY(-3px)";

                e.currentTarget.style.boxShadow =
                    "0 10px 25px rgba(0,0,0,.08)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform =
                    "translateY(0)";

                e.currentTarget.style.boxShadow =
                    "none";
            }}
        >

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "18px",
                    gap: "10px",
                }}
            >

                <div
                    style={{
                        width: "48px",
                        height: "48px",
                        minWidth: "48px",
                        borderRadius: "12px",
                        background: `${color}15`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color,
                        fontSize: "22px",
                    }}
                >
                    {renderIcon()}
                </div>

                <span
                    style={{
                        fontSize: "13px",
                        color: "#64748b",
                        fontWeight: 600,
                        textAlign: "right",
                    }}
                >
                    {title}
                </span>

            </div>

            <h2
                style={{
                    margin: 0,
                    fontSize: "34px",
                    color: "#0f172a",
                    lineHeight: 1.2,
                }}
            >
                {value}
            </h2>

            {subtitle && (
                <p
                    style={{
                        marginTop: "8px",
                        marginBottom: 0,
                        color: "#64748b",
                        fontSize: "14px",
                    }}
                >
                    {subtitle}
                </p>
            )}

        </div>
    );
};

StatCard.propTypes = {
    title: PropTypes.string.isRequired,

    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,

    subtitle: PropTypes.string,

    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),

    color: PropTypes.string,

    onClick: PropTypes.func,
};

export default StatCard;
